// pages/module-pages/reviews/UpdateReviewPage.tsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BaseReview, Review } from "../../../types/features/Review";
import useReviews from "../../../hooks/features/reviews/useReviews";
import ReviewForm from "../../../components/shared/reviews/ReviewForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import useCustomParams from "../../../hooks/core/useCustomParams";

export default function UpdateReviewPage() {
  const { id } = useCustomParams();
  const navigate = useNavigate();
  const { fetchReviewById, updateReview } = useReviews();
  const [review, setReview] = useState<Review | null>(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    loadReview();
  }, [id]);

  const loadReview = async () => {
    if (id) {
      const data = await fetchReviewById(id);
      if (data) {
        setReview(data);
      }
      setLoading(false);
    }
  };

  const handleSubmit = async (data: BaseReview) => {
    setIsLoading(true);
    const slug = `${data.user_name.toLowerCase().replace(/\s+/g, "-")}-${data.rating}-etoiles`;
    const success = await updateReview(id!, { ...data, slug });
    setIsLoading(false);
    if (success) {
      navigate(-1);
      setIsSuccess(true);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <PageLayout title="Modifier un avis" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Modifier l'avis</h1>
          <p className="text-gray-500 mt-1">Modifiez les informations de l'avis</p>
        </div>
        <ReviewForm
          isSuccess={isSuccess}
          initialData={review as Review}
          isEdit={true}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </PageContainer>
    </PageLayout>
  );
}
